/**
 * @see https://stackoverflow.com/a/64659569
 */
export class TopoSort {


    public static sort(points: e5.IPoint[], threshold: number): e5.IPoint[] {
        return this._sort(points, threshold);
    }

    private static _sort(points: e5.IPoint[], threshold: number, result: e5.IPoint[] = []) {



        if(points.length === 0){
            return result;
        }

        if(points.length === 1){
            result.push(points[0]);
            return result;
        }

        points = points.slice();

        var topLeft = this.getTopLeft(points);
        var topRight = this.getTopRight(points);

        // return [topRight];

        if (!topLeft) {
            return result;
        }



        // var distToLine = points.map((p) => {
        //     return {
        //         d: this.pDistance(p.x, p.y, topLeft.x, topLeft.y, topRight.x, topRight.y),
        //         p: p
        //     }
        // });

        // var dists = distToLine.sort((a, b) => a.d - b.d);
        // if(dists[0])

        var row: e5.IPoint[] = [];
        for (var p of points) {
            var dist = this.pDistance(p.x, p.y, topLeft.x, topLeft.y, topRight.x, topRight.y);
            if (dist <= threshold) {
                row.push(p);
            }
        }


        for(var p of row){
            points.splice(points.indexOf(p), 1);
        }

        row.sort((a, b) => a.x - b.x);
        for (var p of row) {
            result.push(p);
        }

        if (points.length > 0) {
            this._sort(points, threshold, result);
        }

        return result;
    }

    private static getTopLeft(points: e5.IPoint[]): e5.IPoint {

        if (points.length === 0) {
            return null;
        }

        if (points.length === 1) {
            return points[0];
        }

        return points.sort((a, b) => {
            return e5.Point.magnitude(a) - e5.Point.magnitude(b);
        })[0];
    }


    private static getTopRight(points: e5.IPoint[]): e5.IPoint {

        if (points.length === 0) {
            return null;
        }

        if (points.length === 1) {
            return points[0];
        }


        var maxX = points.sort((a, b) => {
            return b.x - a.x;
        })[0];

        var maxY = points.sort((a, b) => {
            return a.y - b.y;
        })[0];

        var topRight: e5.IPoint = { x: maxX.x, y: maxY.y };

        return points.sort((a, b) => {
            return e5.Point.distance(a, topRight) - e5.Point.distance(b, topRight);
        })[0];
    }

    private static pDistance(x: number, y: number, x1: number, y1: number, x2: number, y2: number) {

        var A = x - x1;
        var B = y - y1;
        var C = x2 - x1;
        var D = y2 - y1;

        var dot = A * C + B * D;
        var len_sq = C * C + D * D;
        var param = -1;
        if (len_sq != 0) //in case of 0 length line
            param = dot / len_sq;

        var xx, yy;

        if (param < 0) {
            xx = x1;
            yy = y1;
        }
        else if (param > 1) {
            xx = x2;
            yy = y2;
        }
        else {
            xx = x1 + param * C;
            yy = y1 + param * D;
        }

        var dx = x - xx;
        var dy = y - yy;
        return Math.sqrt(dx * dx + dy * dy);
    }
}